module.exports = __webpack_public_path__ + "static/media/rg-dark-triange.892433c2.svg";